import { Typography } from "@carrotfertility/carotene-core"
import React from "react"

/**
 * A "hello world" placeholder from the telemedicine PoC package. It exists to prove the package
 * builds, is consumable by the host, and themes off the host's carotene `ThemeProvider`. Rendered
 * on the existing booking PoC page (`/telemedicine/booking`, gated by `telemedicine-booking-flow`).
 */
export function HelloWorld(): JSX.Element {
  return <Typography>Hello, world — from @internal/telemedicine</Typography>
}
